// src/components/RestaurantSidebar.js
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../firebase';
import SidebarToggle from './SidebarToggle';
import { useLanguage } from '../contexts/LanguageContext';
import './RestaurantSidebar.css';

const RestaurantSidebar = () => {
  const navigate = useNavigate();
  const restaurantName = localStorage.getItem('restaurantName') || 'المطعم';
  const { t, language } = useLanguage();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  // التحقق من تغيير حجم الشاشة
  useEffect(() => {
    const handleResize = () => {
      const newIsMobile = window.innerWidth <= 768;
      setIsMobile(newIsMobile);
      if (!newIsMobile) {
        setIsSidebarOpen(false);
      }
    };
    
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

 // src/components/RestaurantSidebar.js (continuação)
 const handleLogout = async () => {
  try {
    await signOut(auth);
    localStorage.removeItem('restaurantId');
    localStorage.removeItem('restaurantName');
    localStorage.removeItem('restaurantEmail');
    localStorage.removeItem('userRole');
    navigate('/restaurant/login');
  } catch (error) {
    console.error('خطأ في تسجيل الخروج:', error);
  }
};

// إغلاق القائمة عند النقر على أي رابط في الأجهزة المحمولة
const handleLinkClick = () => {
  if (isMobile) {
    setIsSidebarOpen(false);
  }
};

return (
  <>
    {isMobile && (
      <SidebarToggle isOpen={isSidebarOpen} toggle={toggleSidebar} />
    )}
    <div className={`restaurant-sidebar ${isSidebarOpen ? 'show' : ''} ${language === 'ar' ? 'sidebar-rtl' : 'sidebar-ltr'}`}>
      <div className="restaurant-sidebar-header">
        <h2>AT Delivery</h2>
        <p>{restaurantName}</p>
      </div>

      <div className="restaurant-sidebar-menu">
        <NavLink 
          to="/restaurant/dashboard" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">🏠</span>
          <span className="menu-text">{t('home')}</span>
        </NavLink>

        <NavLink 
          to="/restaurant/orders/new" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">➕</span>
          <span className="menu-text">{t('newOrder')}</span>
        </NavLink>

        <NavLink 
          to="/restaurant/orders" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">📦</span>
          <span className="menu-text">{t('orders')}</span>
        </NavLink>

        <NavLink 
          to="/restaurant/reports" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">📊</span>
          <span className="menu-text">{t('reports')}</span>
        </NavLink>

        <NavLink 
          to="/restaurant/wallet" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">💰</span>
          <span className="menu-text">{t('wallet')}</span>
        </NavLink>

        <NavLink 
          to="/restaurant/settings" 
          className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
          onClick={handleLinkClick}
        >
          <span className="menu-icon">⚙️</span>
          <span className="menu-text">{t('settings')}</span>
        </NavLink>
      </div>
      <NavLink 
  to="/restaurant/chat" 
  className={({ isActive }) => isActive ? 'menu-item active' : 'menu-item'}
  onClick={handleLinkClick}
>
  <span className="menu-icon">💬</span>
  <span className="menu-text">{t('chat_with_admin')}</span>
</NavLink>

      <div className="restaurant-sidebar-footer">
        <button className="logout-button" onClick={handleLogout}>
          <span className="logout-icon">🚪</span>
          <span className="logout-text">{t('logout')}</span>
        </button>
      </div>
    </div>
    
    {/* Overlay لإغلاق السايدبار عند النقر خارجه في الأجهزة المحمولة */}
    {isMobile && isSidebarOpen && (
      <div 
        className="sidebar-overlay" 
        onClick={() => setIsSidebarOpen(false)}
      ></div>
    )}
  </>
);
};

export default RestaurantSidebar;